'use client';
var getTextDecoration = function(options) {
    var underline = options.underline, strikethrough = options.strikethrough;
    var styles = [];
    if (underline) {
        styles.push("underline");
    }
    if (strikethrough) {
        styles.push("line-through");
    }
    return styles.length > 0 ? styles.join(" ") : "none";
};

export { getTextDecoration };
